var React = require('react');

function IcRoundPlay (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"15","cy":"15","r":"15","fill":"white","key":0}),React.createElement("path",{"d":"M11.5 19.6384V11.3616C11.5 10.9777 11.9147 10.737 12.2481 10.9275L19.4903 15.0659C19.8262 15.2578 19.8262 15.7422 19.4903 15.9341L12.2481 20.0725C11.9147 20.263 11.5 20.0223 11.5 19.6384Z","fill":"black","key":1})]);
}

IcRoundPlay.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none"};

module.exports = IcRoundPlay;

IcRoundPlay.default = IcRoundPlay;
